import { useEffect, useRef } from 'react'
import { useMutation, useQuery } from '@tanstack/react-query'
import type { ThemeName } from '@lunary/ui-tokens'
import type { ProfileResponseDto } from '@lunary/api-client'
import { api } from '../api/client'
import { applyRemoteTheme, savedThemeChoice, setTheme } from './theme'

const patchTheme = (theme: ThemeName | null) => api.patch<ProfileResponseDto>('/users/me/theme', { theme })

export function useThemeSync(enabled: boolean) {
  const profile = useQuery({
    queryKey: ['profile', 'theme'],
    queryFn: () => api.get<ProfileResponseDto>('/users/me'),
    enabled,
    retry: false,
  })
  const { mutate } = useMutation({ mutationFn: patchTheme })
  const synced = useRef(false)
  const loaded = profile.data

  useEffect(() => {
    if (!enabled) synced.current = false
    if (!loaded || synced.current) return
    synced.current = true
    if (loaded.theme) {
      applyRemoteTheme(loaded.theme)
      return
    }
    const local = savedThemeChoice()
    if (local) mutate(local)
  }, [enabled, loaded, mutate])

  return (theme: ThemeName) => {
    setTheme(theme)
    if (enabled) mutate(theme)
  }
}
